export enum BodyType {
	STUDENT_ASSOCIATION = 'student_association',
	PARTNER = 'partner',
	MEMBER = 'member',
	QUALITY_LABEL = 'quality_label',
	RANKING_INSTITUTE = 'ranking_institute',
	ACCREDITATION_INSTITUTE = 'accreditation_institute',
	SCHOLARSHIP_PROVIDER = 'scholarship_provider',
}
